export enum AdsTxtStatus {
  Found,
  NotFound,
  Scanning,
}
